
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('rect',{attrs:{"x":"-6","y":"9","width":"12","height":"12","rx":".767","fill":"#B4BCCF"}}),_c('rect',{attrs:{"x":"24","y":"9","width":"12","height":"12","rx":".767","fill":"#B4BCCF"}}),_c('rect',{attrs:{"x":"8","y":"8","width":"14","height":"14","rx":"7","fill":"#525F7F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v30H0z"}})])])])
          )
        }
      }
    